import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let ourOffice = document.querySelector('.build-item');

if(ourOffice) {
    buildInit();
}

function buildInit() {
    let buildItems = gsap.utils.toArray('.build-item__container');
    // let contactContent = gsap.utils.toArray('.our-offices__items-content');

    function toggleClassElement(item, elClass) {
        item.classList.add(elClass)
    }

    buildItems.forEach((item) => {
        ScrollTrigger.create({
            trigger: item,
            start: 'top 70%',
            // end: 'bottom 30%',
            // toggleClass: 'active',
            // toggleActions: "restart none none none",
            // markers: true,

            onEnter: () => toggleClassElement(item, 'build-item__container--active'),
            // onLeaveBack: () => toggleClassElement(item, 'our-offices__items-image--active'),
        })
    })
}